module.exports = __webpack_public_path__ + "static/media/en.526d1476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/en.png
// module id = 113
// module chunks = 0